"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSpecialCharacters = exports.setTargetURL = exports.deepMerge = exports.setEventAction = void 0;
exports.isRealObject = isRealObject;
exports.mergeFirstLevel = mergeFirstLevel;
const setHeadlessUrl_1 = require("./setHeadlessUrl");
function isRealObject(obj) {
    return Boolean(obj && typeof obj === 'object' && !Array.isArray(obj));
}
const setEventAction = (trackingService, displayMode, link) => {
    let action = '';
    if (displayMode === 'chatbot') {
        action = 'content';
    }
    else if (displayMode === 'page' || displayMode === 'tab') {
        action = (trackingService === null || trackingService === void 0 ? void 0 : trackingService.evaluateLinkType(link)) || '';
    }
    else if (displayMode === 'layer') {
        action = 'internal_link';
    }
    return action;
};
exports.setEventAction = setEventAction;
function mergeFirstLevel(original, update) {
    if (!original) {
        return update;
    }
    const copy = Object.assign({}, original);
    Object.entries(update).forEach(([key, value]) => {
        const originalValue = copy[key];
        // original didn't have the key => add it
        if (!originalValue) {
            copy[key] = value;
            return;
        }
        // non-objects (including) arrays can't be merged => replace original value
        if (!isRealObject(originalValue) || !isRealObject(value)) {
            copy[key] = value;
            return;
        }
        // both original and update contain the key and both values are objects => merge first level
        copy[key] = Object.assign(Object.assign({}, originalValue), value);
    });
    return copy;
}
/* eslint-disable no-restricted-syntax */
const deepMerge = (target, ...sources) => {
    if (!sources.length) {
        return target;
    }
    const source = sources.shift();
    if (source instanceof Object && !Array.isArray(source)) {
        for (const key in source) {
            if (source[key] instanceof Object && !Array.isArray(source[key])) {
                if (!target[key])
                    Object.assign(target, { [key]: {} });
                (0, exports.deepMerge)(target[key], source[key]);
            }
            else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }
    else if (Array.isArray(source)) {
        // eslint-disable-next-line no-param-reassign
        target = source;
    }
    return (0, exports.deepMerge)(target, ...sources);
};
exports.deepMerge = deepMerge;
/* eslint-enable no-restricted-syntax */
const completeTargetURL = (targetURL) => {
    const { host } = document.location;
    if (targetURL.startsWith('/')) {
        return `${host}${targetURL}`;
    }
    return targetURL;
};
const setTargetURL = (url, openInTabOrLayer) => {
    if (openInTabOrLayer === 'layer') {
        return completeTargetURL(`${(0, setHeadlessUrl_1.setHeadlessUrl)(url)}`);
    }
    if (openInTabOrLayer === 'chatbot') {
        // always empty if chatbot is selected }
        return '';
    }
    return completeTargetURL(url);
};
exports.setTargetURL = setTargetURL;
const removeSpecialCharacters = (text) => {
    if (!text) {
        return '';
    }
    return text
        .replace(/&#8203;/gi, '')
        .replace(/&zwnj;/gi, '')
        .replace(/&nbsp;/gi, '');
};
exports.removeSpecialCharacters = removeSpecialCharacters;
//# sourceMappingURL=utils.js.map